import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { graphql, QueryRenderer } from "react-relay";
import { HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Display from "../../Components/Display";
import Navbar from "../BannerItems/Components/Navigation";
import environment from "../../Environment";
import PageSelector from "../../Components/PageSelector";

const query = graphql`
    query Elements_Query($id: ID!) {
        node(id: $id) {
            name
            id
            content
            __typename
            parent {
                id
                name
                __typename
                children {
                    id
                    name
                    __typename
                    children {
                        id
                        name
                        __typename
                    }
                }
                parent {
                    id
                    name
                    __typename
                    children {
                        id
                        name
                        __typename
                    }
                }
            }
            children {
                id
                name
                __typename
                children {
                    id
                    name
                    __typename
                }
            }
        }
    }

`;

function getNodeArray(data) {
  let parent = getParents(data);
  let children = getChildren(data);
  if (parent && children) {
    return [...parent, data, ...children];
  }
}

function getParents(data) {
  if (data.hasOwnProperty("parent") && data.parent !== null) {
    let parent = getNodeArray(data.parent);
    return [data.parent, ...parent];
  }
  return [];
}

function getChildren(data) {
  if (data.hasOwnProperty("children") && data.children !== null && data.children.length > 0) {
    let children = data.children.map(child => getChildren(child)).reduce((acc, data) => {
      acc.push(...data);
      return acc;
    }, []);
    return [...data.children, ...children]
  }
  return [];
}

function getRoot(data) {
  console.log(data.parent);
  if (data.hasOwnProperty("parent") && data.parent !== null) {
    return getRoot(data.parent);
  }
  return data;
}

class Elements extends Component {
  constructor(props) {
    super(props);
  }
 componentDidMount() {
   window.scrollTo(0, 0);
   if(this.props.location.pathname) {
     window.dendrogramViewLocation = this.props.location.pathname;
    }
  }

  render() {
    let id = this.props.match.params.id;

    console.log(this.props.match.params.id);
    return (
      <div className="App">
        <HelmetTitle title="Principles to grow your ventures" />
        <Layout
          head={<Navbar />} 
          elementHead={<React.Fragment>
          <div className="w-100 bg-gray mt-1 py-5" style={{position: "relative", top: "-3px", zIndex: "2"}}>
          <div className="container text-center">
          <QueryRenderer
            query={query}
            environment={environment}
            variables={{ id }}
            render={({ error, props }) => {
              if (error || (props && !props.node)) {
                return <div>Error</div>;
              }

              if (!props) {
                return <div>Loading...</div>;
              }

              let node = props.node;

              let rootNode = getRoot(node);

              // let rootNode = { name : "test" };

              console.log(props.node);
              console.log(rootNode);


              switch (props.node.__typename) {
                case "Element":
                  let joinedChildren = node.children.reduce((arr, child) => {
                    arr.push(...child.children);
                    return arr;
                  }, []);

                  return (
                    <div>
                      <PageSelector name={node.name} id={node.id} />{" > "}
                      <PageSelector list={node.children} listType={"Theme"}/>{" > "}
                      <PageSelector list={joinedChildren} listType={"Principle"}/>
                    </div>);
                case "Theme":
                  return (
                    <div>
                      <PageSelector name={node.parent.name} id={node.parent.id} />{" > "}
                      <PageSelector name={node.name} id={node.id} />{" > "}
                      <PageSelector list={node.children} listType={"Principle"}/>
                    </div>);
                case "Principle":
                  return (
                    <div>
                      <PageSelector name={node.parent.parent.name} id={node.parent.parent.id} />{" > "}
                      <PageSelector name={node.parent.name} id={node.parent.id} />{" > "}
                      <PageSelector name={node.name} id={node.id} />
                    </div>);
              }

              return <div>
                <PageSelector name={rootNode.name} id={rootNode.id} />
                <PageSelector name={rootNode.children[0].name} id={rootNode.children[0].id} />
                <PageSelector name={rootNode.children[0].children[0].name} id={rootNode.children[0].children[0].id} />
              </div>;
            }}
          /></div></div>
        </React.Fragment>} 
        body={<Display id={id} />} 
        />
      </div>);
  }
}

export default withRouter(Elements)



// WEBPACK FOOTER //
// ./src/Pages/Elements/index.js